const obj = JSON.parse(localStorage.getItem("authUser"));
let guard = obj?.guard;
export default guard;
